import React from 'react';
import MessageInput from '../../message-input/message-input';
import SimpleLegalQueryProgress from '../../legal-query-progress/simple-legal-query-progress';
import { useAppSelector } from '../../../redux/store';
import { selectHasActiveProgressForChat } from '../../../redux/slices/simpleLegalProgressSlice';
import { getLanguageDirection } from '../../../i18n/config';
import { useTranslation } from 'react-i18next';

const ChatInputContainer: React.FC = () => {
  const { i18n } = useTranslation();

  const currentChatId = useAppSelector(state => state.ChatReducer.currentChatId);
  const hasActiveProgress = useAppSelector(state =>
    currentChatId ? selectHasActiveProgressForChat(state, currentChatId) : false
  );

  return (
    <div className="px-6 py-4 border-t border-border bg-card backdrop-blur-sm sticky bottom-0 z-[5] shadow-[0_-4px_20px_rgba(0,0,0,0.03)]">
      <div
        dir={getLanguageDirection(i18n.language)}
        className="max-w-[900px] mx-auto relative"
        style={{
          /* fade-up gradient behind the input */
        }}
      >
        {hasActiveProgress && currentChatId ? (
          <SimpleLegalQueryProgress chatId={currentChatId} compact={true} />
        ) : (
          <MessageInput />
        )}
      </div>
    </div>
  );
};

export default ChatInputContainer;
